import "./Commercial.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import CommercialServices from "./sections/CommercialServices";
import ContactCta from "./sections/ContactCta";
import Footer from "@/reusable_sections/Footer";
export default function CommercialPage() {
  return <div>
      <Header />
      <Hero />
      <CommercialServices />
      <ContactCta />
      <Footer />
    </div>;
}